/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { css } from '@emotion/core'
import React from 'react'
import { useCalculator } from '../use-calculator'
import { fmt, arrayFrom } from '../../twd'

export const CouponsByYear = () => {

    const { calcOutput:co } = useCalculator()
    const payments = arrayFrom(co.paymentsByYears)
    const total = payments
        .reduce((x, {interest, principal}) => x + interest + principal, 0)

    return <React.Fragment>
        <div className='table-responsive' css={stickyTableCss}>
        <table className='table table-striped coupon-payments' style={{marginBottom: 0}}>
        <thead>
            <tr>
                <th>Date</th>
                <th className='text-right'>Payment amount</th>
            </tr>
        </thead>

        <tbody>
            {payments.map(({date, interest, principal}, i) => {
                return <tr key={i}>
                    <td>{i===0 ? 'YTD ' : ''}{fmt.fmtDt(date, 'yyyy')} {interest && principal ? '*' : ''}</td>
                    <td className="text-right">
                        {fmt.money(interest + principal)}
                    </td>
                </tr>
            })}
        </tbody>

        <tfoot>
            <tr>
                <td className="text-bold">Total</td>
                <td className="text-bold text-right">{fmt.money(total)}</td>
            </tr>
        </tfoot>

        </table>
        </div>
        <div>
        <div className="vertical-offset-base">
        * Includes interest and principal payment
        </div>
        </div>
    </React.Fragment>
}


const stickyTableCss = css`
    table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
    }

    thead, tfoot {
        display: table;
        width: 100%
    }

    tbody {
        display: block;
        max-height: 350px;
        overflow-y: auto;
        --webkit-overflow-scrolling: touch;
    }

    tbody tr { display: flex; }
    th:nth-child(1), td:nth-child(1) { width: 50%; }
    th:nth-child(2), td:nth-child(2) { width: 50%; }
`


// WEBPACK FOOTER //
// ./src/calculator/calc-coupons/coupons-by-year.js